module.exports = __webpack_public_path__ + "static/img/znxg@2x.21af69bb.png";